<template>
  <div class="home">
    <Encabezado></Encabezado>

    <!-- Modal -->
    <div v-if="mostrandoModalFirma">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    @click="mostrandoModalFirma = false"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Firme dentro del cuadro</h4>
                </div>
                <div class="modal-body">
                  <div class="marcoFirma">
                    <VueSignaturePad
                      width="100%"
                      height="125px"
                      ref="signaturePad"
                      :customStyle="estilosCajaFirma"
                      :options="opcionesCajaFirma"
                    />
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    @click="mostrandoModalFirma = false"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="salvarFirma()"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- Fin Modal -->

    <div id="content" class="snap-content bg-home">
      <div class="container">
        <div class="header-clear"></div>
        <div id="itemList">
          <div class="itemList-controls">
            <div class="title">
              <h3>Documentos Generales</h3>
            </div>
          </div>
          <div v-if="bloqueo" class="alert alert-danger">
            <h3 class="text-center">
              Tiene Ud. documento/s pendiente/s de <b>firma</b> y/o
              <b>acuse de recibo</b>.
            </h3>
          </div>
          <div class="itemList-header">
            <h1>Documentos Generales</h1>
          </div>
          <div class="itemList-content row">
            <div
              v-if="ficheros.length == 0"
              class="AdvanceRequest-title col-md-12 NotFound text-center"
            >
              No hay resultados
            </div>
            <section v-else id="no-more-tables" class="col-md-12 text-center">
              <table class="table" id="tblGeneralLeave">
                <thead>
                  <tr>
                    <th class="colDate">Id</th>
                    <th class="colDate">Nombre</th>
                    <th class="colType">Grupo</th>
                    <th class="colType">Acuse / Firma</th>
                    <th class="colAction">Descarga</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fichero in ficheros">
                    <td class="colDate" data-title="Id : ">
                      {{ fichero.id }}
                    </td>
                    <td class="colDate" data-title="Nombre : ">
                      {{ fichero.nombre }}
                    </td>
                    <td class="colType" data-title="Grupo : ">
                      {{ fichero.grupo }}
                    </td>
                    <td
                      v-if="!idDocumentosEnProceso.includes(fichero.id)"
                      class="colType"
                      data-title="Acuse : "
                    >
                      <button
                        v-if="fichero.firmado * 1"
                        class="btn btn-success disabled"
                      >
                        Firmado
                      </button>

                      <button
                        v-else-if="fichero.firma * 1"
                        @click="iniciarFirma(fichero)"
                        title="Haga click aquí para firmar el documento"
                        class="btn btn-danger"
                      >
                        Firmar...
                      </button>

                      <button
                        v-else-if="fichero.acusado * 1"
                        class="btn btn-success disabled"
                      >
                        Recibido
                      </button>

                      <button
                        v-else-if="fichero.acuse * 1"
                        @click="marcarAcuse(fichero)"
                        title="Haga click aquí para enviar acuse de recibo"
                        class="btn btn-danger"
                      >
                        Recibí...
                      </button>
                    </td>
                    <td
                      v-if="idDocumentosEnProceso.includes(fichero.id)"
                      class="colType"
                      data-title="Acuse : "
                    >
                      <button class="btn btn-warning disabled">
                        Espere...
                      </button>
                    </td>
                    <td
                      v-if="!(fichero.Externo * 1)"
                      class="colAction"
                      data-title="Acción : "
                    >
                      <a
                        href="javascript:void(0);"
                        @click="descargarFichero(fichero)"
                      >
                        <font-awesome-icon icon="fa-solid fa-eye" />
                      </a>

                      &nbsp;&nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
          <div class="itemList-footer">
            <div class="pagination text-center Generalleave-paging"></div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import router from "@/router";

export default {
  name: "DocumentosGenerales",
  components: {
    Encabezado,
    Footer,
  },
  data() {
    return {
      opcionesCajaFirma: {
        penColor: "#000",
        backgroundColor: "rgba(255,255,255,1)",
      },
      estilosCajaFirma: {
        margin: "0px 0px 0px 0px",
        padding: "0px 0px 0px 0px",
        "box-sizing": "border-box",
        "border-radius": "0px",
      },
      mostrandoModalFirma: false,
      idFicheroSeleccionado: null,
      idDocumentosEnProceso: [],
    };
  },
  mounted() {
    document.body.classList.remove("bg-login");
    document.body.classList.remove("login-page");
  },
  watch: {
    bloqueo: function (ahora, antes) {
      if (antes == 1 && ahora == 0) {
        router.replace("/");
      }
    },
    ficheros: function (ahora) {
      let idDocumentosPendientesAcuseFirma = ahora
        .filter(function (doc) {
          let acuse = doc.acuse * 1;
          let acusado = doc.acusado * 1;
          let firma = doc.firma * 1;
          let firmado = doc.firmado * 1;

          return (acuse && !acusado) || (firma && !firmado);
        })
        .map((doc) => doc.id);

      let idDocumentosEnProceso = this.idDocumentosEnProceso.filter((doc) =>
        idDocumentosPendientesAcuseFirma.includes(doc),
      );
      this.idDocumentosEnProceso = idDocumentosEnProceso;
    },
  },
  computed: {
    ficheros: function () {
      const ficheros =
        this.$store.state.perfil.documentosGenerales.documentos || [];

      return Array.isArray(ficheros) ? ficheros : [ficheros];
    },
    bloqueo: function () {
      return this.$store.state.perfil.bloqueo * 1;
    },
  },

  methods: {
    formatDate: function (date) {
      return this.moment(date).format("DD/MM/YYYY");
    },
    iniciarFirma: function (fichero) {
      if (fichero.Externo * 1) {
        if (this.$store.state.modoApp) {
          const target =
            window["cordova_iab"] ??
            window["webkit"]?.messageHandlers["cordova_iab"] ??
            window["opener"] ??
            window["parent"] ??
            window;

          const data = JSON.stringify({
            event: "sign",
            url: encodeURI(`${fichero.ruta}`),
          });

          console.log(
            `llamando al parent para iniciar la firma externa: ${data}`,
          );

          target.postMessage(data, "*");
          return;
        }

        console.log("redireccionado a: ", `${fichero.ruta}`);

        window.location.href = `${fichero.ruta}`;
        return;
      }
      this.idFicheroSeleccionado = fichero.id;
      this.mostrandoModalFirma = true;
    },
    salvarFirma: function () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature(
        "image/jpeg",
        0.1,
      );
      const firma = isEmpty ? "" : data.split(",")[1];

      // console.log(data);

      // console.log(firma);

      if (isEmpty) return alert("¡firma vacía!");

      this.mostrandoModalFirma = false;

      this.idDocumentosEnProceso.push(this.idFicheroSeleccionado);

      this.$store.dispatch("establecerEstadoDocumentoGeneral", {
        idDocumento: this.idFicheroSeleccionado,
        acuseFirma: 2,
        firma: firma,
      });
    },
    marcarAcuse: function (fichero) {
      this.idDocumentosEnProceso.push(fichero.id);

      this.$store.dispatch("establecerEstadoDocumentoGeneral", {
        idDocumento: fichero.id,
        acuseFirma: 1,
        firma: "",
      });
    },
    descargarFichero: function (fichero) {
      this.$store.dispatch("descargarDocumentoGeneral", {
        documento: fichero.ruta,
      });

      this.$store.dispatch("establecerEstadoDocumentoGeneral", {
        idDocumento: fichero.id,
        acuseFirma: 0,
        firma: "",
      });

      // if (!(fichero.acuse * 1) && !(fichero.firma * 1)) {
      // 	console.log("dentro");
      // 	this.$store.dispatch("establecerEstadoDocumentoGeneral", {
      // 		idDocumento: fichero.id,
      // 		acuseFirma: 0,
      // 		firma: "",
      // 	});
      // }
    },
  },
};
</script>

<style>
@import "../assets/styles/home.css";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.modal-dialog {
  top: 50px !important;
}
.marcoFirma {
  border: red 3px solid;
}
</style>
